import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '@app/helpers/authProvider';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ENV } from "@app/constants/env";

const rawBaseQuery = fetchBaseQuery({
    baseUrl: ENV.BASE_API_URL +ENV.JOB_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    incomingArgs,
    api,
    extraOptions
) => {
    let args: string | FetchArgs = incomingArgs;

    if (typeof args === 'string') {
        args = { url: args };
    }

  try {
    const token = await getToken();
    if (token) {
      let headers: Record<string, string> = {};
      if ((args as FetchArgs).headers) {
    if (typeof (args as FetchArgs).headers === 'object') {
      headers = { ...(args as FetchArgs).headers as Record<string, string> };
    }
      }
      headers['Authorization'] = `Bearer ${token}`;
      (args as FetchArgs).headers = headers;
    }
    const result = await rawBaseQuery(args, api, extraOptions);
    return result;
  } catch (error) {
    return {
      error: {
        status: 'CUSTOM_ERROR',
        error: String(error),
        data: undefined,
      } as FetchBaseQueryError,
    };
  }
};

// Storage Label Types
export interface StorageLabelEntity {
  LabeleId?: number;
  ServiceType?: string;
  WosLength?: number;
  WosWidth?: number;
  WosHeight?: number;
  WosVolume?: number;
  ScanDateTime?: string;
  ScanbyUsername?: string;
  Printed?: string;
  InvoiceNo?: string;
  Mstr_WOService_Id?: number;
  ImageDocumentUploadID?: string;
  SignatureDocumentUploadID?: string;
}

export const storageLabelAPI = createApi({
  reducerPath: 'storageLabelAPI',
  baseQuery: authBaseQuery,
  tagTypes: ['StorageLabel'],
  endpoints: (builder) => ({
    getStorageLabels: builder.query<any, string>({
      query: (invoiceNo) => ({
        url: ``,
        method: 'GET',
      }),
      transformResponse: (response: any) => Array.isArray(response) ? response : [],
      providesTags: ['StorageLabel'],
    }),
    getWOSStorageLabels: builder.query<any, number>({
      query: (mstrWOSServiceId) => ({
        url: `StorageLabel/GetWOSStorageLabels/${mstrWOSServiceId}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        console.log('🔍 GetWOSStorageLabels RAW response:', response);
        const result = Array.isArray(response) ? response : [];
        console.log('🔍 GetWOSStorageLabels transformed result:', result);
        if (result.length > 0) {
          console.log('🔍 First item keys:', Object.keys(result[0]));
          console.log('🔍 First item:', result[0]);
        }
        return result;
      },
      providesTags: ['StorageLabel'],
    }),
    deleteStorageLabel: builder.mutation<any, { labelId: number; userId: number }>({
      query: ({ labelId, userId }) => ({
        url: `StorageLabel/DeleteWOSStorageLabel/${labelId}/${userId}`,
        method: 'POST',
      }),
      invalidatesTags: ['StorageLabel'],
    }),
    insertWOSStorageLabel: builder.mutation<any, { userId: number; payload: any }>({
      query: ({ userId, payload }) => ({
        url: `StorageLabel/InsertWOSStorageLabel/${userId}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['StorageLabel'],
    }),
    updatePrintLabel: builder.mutation<any, { userId: string | number; labelId: string | number; payload: any }>({
      query: ({ userId, labelId, payload }) => ({
        url: `StorageLabel/UpdatePrint/${userId}/${labelId}`,
        method: 'POST',
        headers: { 
          'accept': '*/*',
          'Content-Type': 'application/json'
        },
        body: payload,
        responseHandler: 'text',
      }),
      invalidatesTags: ['StorageLabel'],
    }),
  }),
});

export const {
  useGetStorageLabelsQuery,
  useDeleteStorageLabelMutation,
  useGetWOSStorageLabelsQuery,
  useInsertWOSStorageLabelMutation,
  useUpdatePrintLabelMutation,
} = storageLabelAPI;
